import { useDispatch } from 'react-redux'
import { addSnackbar, dismissSnackbar } from '../store/organizationList/actions'

const useNotify = () => {
  const dispatch = useDispatch()

  const show = (message, type = 'success', autoClose = true) => {
    dispatch(addSnackbar(message, type))
    if (autoClose) {
      setTimeout(() => {
        hide()
      }, 3000)
    }
  }

  const hide = () => {
    dispatch(dismissSnackbar())
  }

  return {
    show: show,
    hide: hide
  }
}

export default useNotify
